import { showErrorNotification, Variant } from "@utils/showNotification";

// Utilities

// 403 errors
const getForbiddenChecks = (message: string) => {
  if (message.includes("username/email already exists")) {
    return "forbidden-message-username-email-exists";
  } else if (message.includes("email already exists")) {
    return "forbidden-message-email-exists";
  } else return "forbidden-message";
};

// 409 errors
const getActionBlockedChecks = (message: string) => {
  if (message.includes("Lab service has been paid")) {
    return "action-blocked-lab-message";
  } else if (message.toLowerCase().includes("appointment slot")) {
    return "selected-slot-no-longer-available";
  } else return "action-blocked-message";
};

export const useQueryErrorHandling = () => {
  const handleErrors = (res: any, variant: Variant, id?: string) => {
    // 500 error from backend does not send a response
    if (res.code === "ERR_NETWORK") {
      showErrorNotification({
        ...(id && { id }),
        title: "oops",
        message: "unexpected-error",
      });
      return;
    }

    switch (res?.response?.status) {
      case 401:
        showErrorNotification({
          ...(id && { id }),
          title: "not-authenticated-title",
          message: "not-authenticated-message",
        });
        break;

      case 403:
        if (variant === "mutation") {
          showErrorNotification({
            ...(id && { id }),
            title: "forbidden-title",
            message: getForbiddenChecks(res.response.data.detail),
            variant,
          });
        }
        break;
      case 404:
        showErrorNotification({
          ...(id && { id }),
          title: "not-found-title",
          message: "not-found-message",
          variant,
        });
        break;
      case 400:
      case 422:
        showErrorNotification({
          ...(id && { id }),
          title: "invalid-input-title",
          message: "invalid-input-message",
        });
        break;
      case 409:
        showErrorNotification({
          ...(id && { id }),
          title: "action-blocked-title",
          message: getActionBlockedChecks(res.response.data.detail),
        });
        break;
      default:
        showErrorNotification({
          ...(id && { id }),
          title: "oops",
          message: "unexpected-error",
        });
        break;
    }
  };

  return handleErrors;
};
